"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationManager = void 0;
class NavigationManager {
    static setNavStyles() {
        const navigation = document.querySelector('.navigation__nav');
        const checkBox = document.querySelector('.navigation__checkbox');
        if (checkBox) {
            checkBox.checked = false;
        }
        if (navigation) {
            if (window.innerWidth >= 900) {
                navigation.classList.add('navigation__nav--open');
            }
            else {
                navigation.classList.remove('navigation__nav--open');
            }
        }
    }
    static initialize() {
        window.addEventListener('resize', this.setNavStyles, true);
        this.setNavStyles();
        window.addEventListener('scroll', this.handleScroll.bind(this));
        this.handleScroll();
        const navigation = document.querySelector('.navigation__nav');
        const checkBox = document.querySelector('.navigation__checkbox');
        const navBtn = document.querySelector('.navigation__button');
        if (navBtn && navigation && checkBox) {
            navBtn.addEventListener('click', () => {
                if (checkBox.checked) {
                    navigation.classList.remove('navigation__nav--open');
                }
                else {
                    navigation.classList.add('navigation__nav--open');
                }
            });
        }
        // Prevent clicks on active navigation items
        document.querySelectorAll('.navigation__active').forEach(navItem => {
            navItem.addEventListener('click', e => {
                e.preventDefault();
            });
        });
    }
    static handleScroll() {
        const navContainer = document.querySelector('.navigation');
        if (!navContainer)
            return;
        if (window.scrollY > 70) {
            navContainer.classList.add('navigation--scrolled');
        }
        else {
            navContainer.classList.remove('navigation--scrolled');
        }
    }
}
exports.NavigationManager = NavigationManager;
